<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <el-form-item :label="$t('common.date')">
                    <el-date-picker v-model="formInline.data" type="monthrange" range-separator="至"
                      start-placeholder="开始月份" end-placeholder="结束月份">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('common.orgName')">
                    <el-select v-model="formInline.orgId" :placeholder="$t('common.form.choseTip')" filterable
                      size="mini" style="width: 150px">
                      <el-option v-for="item in orgIdList" :key="item.id" :label="item.name"
                        :value="item.id"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="mini" type="primary" @click="onSearch" class="btn-chaxun">{{
                      $t('common.btn.search') }}</el-button>
                    <el-button size="mini" @click="onClear" class="btn-del">{{ $t('common.btn.cancel') }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <el-button v-if="isPrimaryKey('VEHICLEANALYSIS_VEHICLEORGREPORT_CHANGE_DOWN')" type="text"
                  @click="downCar">{{ $t('common.btn.download') }}</el-button>
              </div>
              <div class="rightAll-table">
                <el-table ref="dataTable" :height="tableHeight" border stripe :span-method="arraySpanMethod" :data="displayData" :cell-class-name="setClass"
                  style="width: 100%" v-loading="loading" element-loading-text="正在加载..."
                  element-loading-spinner="el-icon-loading" @scroll="handleTableScroll">
                  <el-table-column type="index" :label="$t('common.id')" width="50" align="center">
                  </el-table-column>
                  <template v-for="item in columnList">
                    <template v-if="item.type === 1">
                      <el-table-column :label="item.label" :prop="item.prop" align="center" :width="getColumnWidth(item)">
                    </el-table-column>
                    </template>
                    <template v-if="item.type === 0">
                      <el-table-column :label="item.label" align="center">
                      <el-table-column :prop="item.prop + '.workTime'" label="驾驶总时间" width="110" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.workTimeAvg'" label="人均驾驶时间(时/人/月)" width="110" align="center">
                      </el-table-column>
                      <el-table-column :prop="item.prop + '.workTimeAvgTotal'" label="总人均驾驶时间(时/人/月)" width="120" align="center">
                      </el-table-column>
                    </el-table-column>
                    </template>
                  </template>
                </el-table>

                <div v-if="loadingMore" class="loading-more">
                  <i class="el-icon-loading"></i>
                  <span>正在加载更多数据...</span>
                </div>
                <div v-if="!hasMore && displayData.length > 0" class="no-more">
                  <span>没有更多数据了</span>
                </div>
                <div v-if="displayData.length === 0 && !loading" class="empty-data">
                  <span>暂无数据</span>
                </div>
              </div>
              <!-- <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table> -->
              <!-- <IPagination ref="page" @PageFun="changeSize"></IPagination> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DriverHoursStatistics from "./DriverHoursStatistics";
export default DriverHoursStatistics;
</script>

<style lang="less" scoped>
::v-deep .el-table__row {
  .addBorder {
    background-color: #2a548e !important;
  }
}

::v-deep .el-table th.el-table__cell.is-leaf:nth-child(2) {
  border-right: none;

  .el-table .cell {
    height: 35px;
    line-height: 35px;
  }
}

  .loading-more,
  .no-more,
  .empty-data {
    text-align: center;
    padding: 20px 0;
    color: #999;
    font-size: 14px;

    i {
      margin-right: 8px;
    }
  }

  .loading-more {
    i {
      animation: rotating 2s linear infinite;
    }
  }

  @keyframes rotating {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  // 设置表格高度，使其可以滚动
  .rightAll-table {
      position: relative;
    }

@import "../../../assets/styles/Style.less";
</style>
